// extracted by mini-css-extract-plugin
module.exports = {"modal-content":"modal_modal-content__fE69w","modal-body":"modal_modal-body__oleS3"};